exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-1d1a5bbe] {\n  max-width: 100%;\n}\n.image-container[data-v-1d1a5bbe] {\n  border: transparent;\n  border-style: dashed;\n  border-radius: .5em;\n  margin-right: .1em;\n  margin-left: .1em;\n  min-height: 240px;\n}\n.image-container img[data-v-1d1a5bbe] {\n  border-radius: .5em;\n}\n.bordered[data-v-1d1a5bbe] {\n  border-color: #e9e9e9;\n}\n.invalid-image[data-v-1d1a5bbe] {\n  border-color: red;\n}\n.default-upload[data-v-1d1a5bbe] {\n  width: .1px;\n  height: .1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n}\n.swell-upload[data-v-1d1a5bbe] {\n  cursor: pointer;\n}\n", ""]);

// exports
